import { sidebarStore } from "Components/Core/Sidebar/SidebarStore";
import { MenuItemWithBadge, SubmenuItem } from "Components/Core/Sidebar/subMenus";
import { userInfoStore } from "Stores";
import { CoreStore } from "Stores/RESTStore/CoreStore";

type SubMenus = "PRIVATE" | "PUBLIC" | "ORGANISATIONS" | "SYSTEM" | "DELEGATES";

export const subMenuConfig = {
  get config(): SubmenuItem[] {
    const mainModuleChildren = sidebarStore.menu?.find((m) => m.module === "GROUPS")?.children;
    const subModules = mainModuleChildren ? (mainModuleChildren.map((m) => m.module) as SubMenus[]) : null;
    const config = [
      {
        label: <MenuItemWithBadge label={`Public`} store={{} as CoreStore} />,
        link: "public",
      },
      {
        label: <MenuItemWithBadge label={`Private`} store={{} as CoreStore} />,
        link: "private",
      },
    ];

    if (subModules) {
      subModules.includes("ORGANISATIONS") &&
        config.push({
          label: <MenuItemWithBadge label={`Organisations`} store={{} as CoreStore} />,
          link: "organisation",
        });
      subModules.includes("SYSTEM") &&
        config.push({
          label: <MenuItemWithBadge label={`System`} store={{} as CoreStore} />,
          link: "all",
        });
      subModules.includes("DELEGATES") &&
        !userInfoStore.isRestrictedUser &&
        config.push({
          label: <MenuItemWithBadge label={`Delegates`} store={{} as CoreStore} />,
          link: "delegates",
        });
    }

    return config;
  },
};
